/* global G */
import settings from '@tenant/settings'
import routeComposition from 'trait/composition/route'
import { setKey } from 'lib/util'

/**
 * Redirects the user to the OAuth route if they haven't already been logged in.
 *
 * @param {Gaia.Web.Application|Gaia.Mobile.Application} obj the platform Application
 * @returns {(function(): Promise<void>)|*}
 */
const redirectGuestToOAuth = obj => async () => {
  const session = obj[G.SESSION][G.STATE][G.META]
  const route = obj[G.STATE][G.ROUTE]

  if (!session && route[G.MODULE] === 'guest') {
    const module = obj[G.SESSION][G.STATE][G.MODULE]
    const { action } = obj[G.ADAPTER][G.ROUTER][G.API]
    const { unregistered, oauth } = obj[G.CONFIGURATION].defaults
    const unregisteredRoute = routeComposition(null, unregistered.action)

    setKey(unregisteredRoute, G.ROUTE, module[G.STATE])
    await action(oauth.action)
  }
}

/**
 * If the OAuth setting is enabled for the current tenant, registers {@link redirectGuestToOAuth} to
 * be triggered on `'gaia:init'`.
 *
 * @param {Gaia.Web.Application|Gaia.Mobile.Application} obj the platform Application
 * @returns {function(*): Promise<*>}
 */
const init = obj => async (args) => {
  const { enabled, auto } = settings?.oauth || {}

  if (enabled && auto) {
    const eventBus = obj[G.EVENTS]

    eventBus.add('gaia:init', redirectGuestToOAuth(obj), { once: true })
  }

  return args
}

export default init
